"use client";
import { useFormattedDate } from "@/hooks/useFormatedData";
import { useLanguageStore } from "@/providers/useLanguageStore";
import React from "react";
import useReferralStore from "@/providers/useReferralStore";
import { generateLinkWithParams } from "@/utils/generateLinkWithParams";
import { normalizeClassroom } from "@/utils/normalizeClassroom";
import CardLiveCourseItems from "../Shared/CardLiveCourseItems";
import { useSearchParams } from "next/navigation";
import { getUtmParams } from "@/utils/getUtmParams";
import { resolveUtmParams } from "@/utils/utmStorage";

interface Schedule {
  day: string;
  since: string;
  to: string;
}
interface CourseItemProps {
  course: {
    _id: string;
    course: string;
    classroom: string;
    schedule: Schedule[];
    initialDate: string;
    slackChannel?: string;
    plan: string;
    coverThumbnail: string;
    mode?: string;
    officeLocation?: string;
    planData?: {
      _id: string;
      name: string;
      promoName?: string;
      promoPercentage?: number;
      priceSchema: number[];
    };
  };
}
const CourseItem: React.FC<CourseItemProps> = ({ course }) => {
  const { translations } = useLanguageStore();
  const formattedDate = useFormattedDate(course.initialDate);
  const { referer, medium } = useReferralStore();
  const searchParams = useSearchParams();
  const currentUtmParams = getUtmParams(searchParams);
  const utmParams = resolveUtmParams(currentUtmParams);
  const normalizedClassroom = normalizeClassroom(course.classroom);
  const checkoutUrl = generateLinkWithParams(
    `https://inscripciones.rollingcodeschool.com/live-courses/checkout/new/${normalizedClassroom}`,
    referer,
    medium,
    utmParams
  );
  return (
    <CardLiveCourseItems
      type="course"
      item={course}
      translations={translations}
      formattedDate={formattedDate}
      normalizedClassroom={normalizedClassroom}
      checkoutUrl={checkoutUrl}
    />
  );
};

export default CourseItem;
